import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../../../../config/Config";


const initialState = {
    loading: false,
    data: null,
    error: null,
    employeList: null,
    contract: null,

}



export const fetchPayrollContract = createAsyncThunk(
    "fetchPayrollContract",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.get(`/crm/payroll/fetch-contract?page=${body.page}&search=${body?.search}`);
            return response.data;
        }
        catch (error) {
            return rejectWithValue(error?.response)
        }
    }
)

export const addPayrollContract = createAsyncThunk(
    "addPayrollContract",
    async (data, { rejectWithValue }) => {
        try {
            const response = await instance.post(
                "/crm/payroll/create-contract",
                data

            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response);
        }
    }
);

export const deleteContractDetails = createAsyncThunk(
    "deleteContractDetails",
    async (pc_id) => {
        try {
            const response = await instance.post(
                `/crm/payroll/delete-contract?pc_id=${pc_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const getAllEmployeeList = createAsyncThunk(
    "getAllEmployeeList",
    async (body, { rejectWithValue }) => {
        try {


            const response = await instance.get(`/crm/employees/get-employee-list`);
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response)
        }
    })


export const PayrollContractSlice = createSlice({
    name: "PayrollContractSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {


        builder.addCase(fetchPayrollContract.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(fetchPayrollContract.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload.count;
        })
        builder.addCase(fetchPayrollContract.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });

        builder.addCase(addPayrollContract.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(addPayrollContract.fulfilled, (state, action) => {
            state.loading = false;
            state.contract = action.payload

        })
        builder.addCase(addPayrollContract.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });
        builder.addCase(deleteContractDetails.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(deleteContractDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.contract = action.payload;
        })
        builder.addCase(deleteContractDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });



        builder.addCase(getAllEmployeeList.pending, (state) => {
            state.loading = true;
            state.response = null;
        });
        builder.addCase(getAllEmployeeList.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.employeList = action.payload;
        });
        builder.addCase(getAllEmployeeList.rejected, (state, action) => {
            state.loading = false;
            state.error = action?.payload?.data;
        })

    }

})

export default PayrollContractSlice.reducer;